var __savedClickedIndex = -1;

angular
  .module("AccountingBoxApp")
  .controller("InboxUploadsCtrl", function(
    $scope,
    $rootScope,
    Attachment,
    LoopBackAuth,
    $state,
    $interval,
    $timeout,
  ) {
    var vm = this;
    vm.apiEndpoint = API_ENDPOINT;
    var uploads;
    $scope.currentCompany = $rootScope.currentCompany;
    /*  function getUploads(cb) {
  uploads = Attachment.query({
  filter: {
  where: {
  transactionId: ''
},
order:'created DESC'
}
}, function(uploads) {
vm.uploads = uploads;
if(cb){
cb();
}
});
}

getUploads();*/

    // vm.uploads = uploads;
    //
    // var stop = $interval(function(){
    //   $timeout(function(){
    //     vm.refreshData();
    //   }, 1);
    // }, 5*1000);
    //
    // // Cancel interval on page changes
    // $scope.$on('$destroy', function() {
    //   $interval.cancel(stop);
    // });
    //
    vm.loading = true;
    vm.uploads = Attachment.query(
      {
        filter: {
          where: {
            transactionId: ""
          },
          order: "created DESC"
        }
      },
      function(attachments) {
        vm.uploads = attachments;
        vm.loading = false;
      }
    );

    vm.refreshData = function() {
      Attachment.query(
        {
          filter: {
            where: {
              transactionId: ""
            },
            order: "created DESC"
          }
        },
        function(attachments) {
          vm.uploads = attachments;
        }
      );
    };
    /*var promise = $interval(getUploads, 5000);

// Cancel interval on page changes
$scope.$on('$destroy', function() {
if (angular.isDefined(promise)) {
$interval.cancel(promise);
promise = undefined;
}
});*/

    vm.token = LoopBackAuth.accessTokenId;
    // var src = new EventSource(API_ENDPOINT + '/Attachments/change-stream?_format=event-source&access_token='+vm.token);
    // var changes = createChangeStream(src);
    //var uploads;

    /*Attachment.find({
filter: {
where: {
transactionId: ''
}
}
}).$promise.then(function(results) {
uploads = new LiveSet(results, changes);
//$scope.colors = set.toLiveArray();
vm.uploads = uploads.toLiveArray();
});*/
    $scope.clickedIndex = __savedClickedIndex;
    vm.openProcessingScreen = function(upload) {
      $scope.clickedIndex = upload.id;
      __savedClickedIndex = upload.id;
      $rootScope.uploadIndex = vm.uploads.indexOf(upload);
      var processingScreen = "purchases";
      if (
        upload.transactionProposal &&
        upload.transactionProposal.transactionType
      ) {
        if (upload.transactionProposal.transactionType === "Sale") {
          processingScreen = "sales";
        } else if (
          upload.transactionProposal.transactionType === "JournalEntry"
        ) {
          processingScreen = "journalEntries";
        }
      }
      setTimeout(function() {
        $state.go("app.company.new." + processingScreen, {
          id: upload.id,
          attachment: upload
        });
      });
    };

    $scope.$on("closedUploadingModal", function() {
      $timeout(function() {
        vm.refreshData();
      }, 1000);
    });

    $scope.$on("uploadAdded", function(e, data) {
      var attachment = data.attachment;
      var type = data.file._file.type.slice(
        data.file._file.type.lastIndexOf("/") + 1
      );
      if (type !== "pdf") {
        attachment.justUploaded = true;
        attachment.file = data.file;
      } else {
        var index = vm.uploads.length;
        setTimeout(function() {
          if(vm.uploads[index]) {
            vm.uploads[index].reload = true;
            $scope.$apply();
          }
        }, 8000);
      }
      vm.uploads.push(data.attachment);
    });
  });
